import { render } from "./SecurityCategoriesConfig.vue?vue&type=template&id=d0ae9190&scoped=true"
import script from "./SecurityCategoriesConfig.vue?vue&type=script&lang=js"
export * from "./SecurityCategoriesConfig.vue?vue&type=script&lang=js"

import "./SecurityCategoriesConfig.vue?vue&type=style&index=0&id=d0ae9190&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d0ae9190"]])

export default __exports__